import { render, staticRenderFns } from "./CommentEmbeddedListRead.vue?vue&type=template&id=d7e6eac6&"
import script from "./CommentEmbeddedListRead.vue?vue&type=script&lang=js&"
export * from "./CommentEmbeddedListRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports